import React, { useState } from 'react'
import { useGetTopicListQuery } from '../../../store/cmsService'
import { Interest, TagIconMap } from '../types'
import InterestTile from './InterestTile'
import TopicsIconMapper from './TopicsIconMapper'

interface TopicsSelectorProps {
  defaultSelected?: number[]
  onChange: (value: number[]) => void
}

const TopicsSelector = ({
  defaultSelected = undefined,
  onChange,
}: TopicsSelectorProps) => {
  const { data } = useGetTopicListQuery()
  const [selected, setSelected] = useState<number[]>(defaultSelected ?? [])
  const tagIconMap: TagIconMap = TopicsIconMapper()

  const matchTag = /alliance|alumni|careers/
  const interests = data?.data
    ?.filter((interest) => {
      const rsmTag = interest.tag?.split('/rsm-')?.pop()
      return !rsmTag?.match(matchTag)
    })
    ?.map((interest) => {
      const tag = interest.tag?.split('/')?.pop()
      return tag ? { ...interest, icon: tagIconMap[tag] } : interest
    }) as Interest[]

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {interests?.map((interest, index) => (
        <InterestTile
          key={interest.tag}
          testId="Topic"
          checked={selected.includes(interest.id)}
          index={index}
          interest={interest}
          onClick={(checked) => {
            const value = checked
              ? [...selected, interest.id]
              : selected.filter((i) => i !== interest.id)
            setSelected(value)
            onChange(value)
          }}
        />
      ))}
    </>
  )
}

export default TopicsSelector
